// check if two arrays with primitive values are equal
// Reference: https://stackoverflow.com/a/16436975
export function arraysEqual(a: Array<string | number | boolean> = [], b: Array<string | number | boolean> = []) {
  if (a === b) return true;
  if (a.length !== b.length) return false;

  const newA = [...a].sort();
  const newB = [...b].sort();

  for (let i = 0; i < newA.length; ++i) {
    if (newA[i] !== newB[i]) return false;
  }

  return true;
}

export const sortBy = (a: string | undefined = '', b: string | undefined = '') =>
  a.toLowerCase().localeCompare(b.toLowerCase());

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat
export const getNumberPercentage = (value = 0, minimumFractionDigits = 0, maximumFractionDigits = 7) => {
  return (
    new Intl.NumberFormat('default', {
      minimumFractionDigits,
      maximumFractionDigits,
    }).format(value) + '%'
  );
};

export function formatFileSize(size: number) {
  const fileSizeExponent = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));

  return (
    Number((size / Math.pow(1024, fileSizeExponent)).toFixed(2)) +
    ' ' +
    ['bytes', 'KB', 'MB', 'GB', 'TB'][fileSizeExponent]
  );
}

export function formatNumber(value: number, digits: number = 0) {
  return value.toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits });
}

// https://stackoverflow.com/a/43467144
export const isValidHttpUrl = (urlValue: string) => {
  let url;

  try {
    url = new URL(urlValue);
  } catch (_) {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
};
